import React from 'react';
import { t } from '../tokens';

interface SettingsPanelProps {
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  onPrivacyPolicyClick?: () => void;
  onContactClick?: () => void;
  onHelpClick?: () => void;
}

const SettingsPanel: React.FC<SettingsPanelProps> = ({
  isOpen,
  onClose,
  children,
  onPrivacyPolicyClick = () => {},
  onContactClick = () => {},
  onHelpClick = () => {}
}) => {

  return (
    <div 
      className={`fixed top-0 right-0 h-full shadow-xl transition-transform duration-300 ease-in-out z-[260] ${
        isOpen ? 'translate-x-0' : 'translate-x-full'
      }`}
      style={{ width: 'min(400px, calc(100vw - 12px))', maxWidth: 'calc(100vw - 12px)', backgroundColor: t.panelBg }}
      data-debug-id="Level-1:SettingsPanel"
    >
      {/* Gold accent stripe */}
      <div className="h-0.5 flex-shrink-0" style={{ background: `linear-gradient(to right, ${t.gold}, #C4903A)` }} />
      <div className="flex flex-col h-full">
        {/* Panel Header */}
        <div className="flex items-center justify-between p-4" style={{ borderBottom: '1px solid rgba(86,70,60,0.5)' }}>
          <h2 className="text-lg font-bold" style={{ fontFamily: 'Kumbh Sans, sans-serif', color: t.gold }}>Settings &amp; Tools</h2>
          <button
            onClick={onClose}
            className="p-2 rounded-md transition-colors"
            style={{ color: t.beige }}
            onMouseEnter={e => (e.currentTarget.style.backgroundColor = 'rgba(86,70,60,0.5)')}
            onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'transparent')}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Panel Content */}
        <div className="flex-1 overflow-y-auto p-4 space-y-6">
          
          {/* Settings Content (MIDI, Preferences, etc.) */}
          {children}

          {/* Privacy Policy, Contact and Help Links */}
          <div className="border-t border-gray-700 pt-4 mt-6">
            <div className="flex justify-center gap-4">
              <button
                onClick={onPrivacyPolicyClick}
                className="text-sm text-gray-400 hover:text-white transition-colors underline"
              >
                Privacy Policy
              </button>
              <button
                onClick={onContactClick}
                className="text-sm text-gray-400 hover:text-white transition-colors underline"
              >
                Contact
              </button>
              <button
                onClick={onHelpClick}
                className="text-sm text-gray-400 hover:text-white transition-colors underline"
              >
                Help
              </button>
              <a
                href="https://blog.chordnotator.com"
                target="_blank"
                rel="noopener"
                className="text-sm text-gray-400 hover:text-white transition-colors underline"
              >
                Blog
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPanel;